module.exports = __webpack_public_path__ + "img/kkb_riggingsteel.01033b25.jpg";